module.exports = __webpack_public_path__ + "img/projectmanagement.fe3f4037.svg";